import { render } from "./BaseTable.vue?vue&type=template&id=656ec90c&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=656ec90c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-656ec90c"

export default script